/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  GetPresentationService,
  IGetPresentationMethods,
  GetCostumeTypeService,
  IGetCostumeTypeMethods,
  CreateBoxService,
  ICreateBoxTypeMethods,
  ICreatePayFACMethods,
  CreatePayFACService,
  GetPreBookedAmtService,
  IGetPreBookedAmtMethods,
  IValidateDiscountMethods,
  ValidateDiscountService,
  IGetMyDiscountMethods,
  GetMyDiscountService
} from "./components";

export type CostumePageAgent = IStaticPageContentMethods &
  IGetPresentationMethods &
  ICreatePayFACMethods &
  IGetCostumeTypeMethods &
  IGetPreBookedAmtMethods &
  ICreateBoxTypeMethods &
  IGetMyDiscountMethods &
  IValidateDiscountMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new GetPresentationService(),
    new GetCostumeTypeService(),
    new CreateBoxService(),
    new CreatePayFACService(),
    new GetPreBookedAmtService(),
    new ValidateDiscountService(),
    new GetMyDiscountService()
  ];
};

export const getAgent = () => {
  return createAgent<CostumePageAgent>({
    plugins: getPlugins(),
  });
};
